import React from 'react';
const { MDBInput } = require('mdbreact');

/*
<CreditCardInput value={(accountNumberOnMount && (accountNumberOnMount === AccountNumber)) ? null : AccountNumber}
                                      error={parseError(accountNumberError, {label:'Card Number'})}
                                      required={true}
                                      name="ccCardNumber"
                                      label="Card Number"
                                      maxLength={16}
                                      onChangeHandler={(val */
interface Props {
    value:string;
    number?:string;
    disabled?: boolean;
    className?: string;
    id?: string;
    name: string;
    label:string;
    maxLength:number;
    datagridfield?:string; //???

    isValid?:boolean;
    error?: string;
    readOnly?:boolean;
    required?:boolean;

    onBlur?: ()=>void;
    onChangeHandler?: (s:string)=>void;
}
interface State {
    isTouched: boolean;
    formattedfNumber: string;
}
/**
 * Simple credit card input that formats credit card number.
 * TODO: detect card type, validate card number
 */
// todo: create a BaseInput component to factor out common code such as calc classNamae, id, tabindex, label, etc.
export class CreditCardInput extends React.Component <Props, State> {
    constructor(props:Props){
        super(props);
        // this.state.number is formatted credit card number '#### #### #### ####'
        this.state = {formattedfNumber: this.formatCreditCardNumber(this.props.number),
                      isTouched: false};
    }

    render() {
        let className = "ui-mdb-input-custom " + (this.props.disabled? "disabled " : "") + (this.props.className || '');

        let id = (!this.props.id || this.props.id === "") ? this.props.name : this.props.id;
        id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");

        let tabindex = this.props.readOnly ? -1 : 0;

        let active = this.state.isTouched || !!this.state.formattedfNumber;
        let label = this.props.label;
        let newlabel = this.props.datagridfield ? '' : (this.props.required || this.props.readOnly || this.props.disabled  ? label : (!active ? label + ' (optional)' : label));

        let hasError = !!this.props.error;

        // use the uncontrolled MDBInput instead of the controlled component Input so have more precise control
        return <div className={ className}>
                <MDBInput
                    tabIndex={tabindex}
                    value={this.state.formattedfNumber}
                    maxLength={this.props.maxLength !== undefined? this.props.maxLength+3: undefined}
                    label={newlabel}
                    labelClass={'no-break ' + (this.props.readOnly ? 'active' : '')}
                    validate={false}
                    onInput={(e: { target: { value: string; }; })=>{
                        let value = e.target.value;
                        this.setState({formattedfNumber: this.formatCreditCardNumber(value)});
                    }}
                    id={id}
                    className = {hasError ? 'is-invalid' : (this.props.isValid ? 'is-valid' : null)}
                    onFocus={this.onFocus}
                    onBlur={this.onBlurHandler}
                >
                </MDBInput>
                <div className={"valid-feedback"}></div>
                <div className={"invalid-feedback"} style={{display: hasError && !this.props.readOnly? 'block': 'none'}}>{this.props.error}</div>
            </div>;
    }

    onFocus = () => {
        this.setState({isTouched : true})
    }

    onBlurHandler = () => {
        this.setState({isTouched: false}, ()=>{
            if(this.props.onChangeHandler){
                const cardNumber = this.stripNonDigit(this.state.formattedfNumber);
                // console.debug(`this.props.onChangeHandler(${cardNumber})`);
                this.props.onChangeHandler(cardNumber);
            }
            this.props.onBlur && this.props.onBlur();
        });
    }

    /**
     * format credit card number and return the number of format #### #### #### ####
     * @param n 
     */
    formatCreditCardNumber(n?:string){
        if(!n) return '';
        
        let n2 = '';
        let digitCnt = 0;
        for(let i=0; i<n.length; i++){
            let cc = n.charCodeAt(i);
            if(cc> 47 && cc < 58){ // digit
                let c = n.charAt(i);
                if(digitCnt>0 && digitCnt % 4 === 0){
                    n2 = n2 + ' ';
                }
                n2 = n2 + c;
                digitCnt ++;
            }
        }
        // console.log(`format ${n} as ${n2}`);
        return n2;
    }

    /**
     * strip non-digit chars of n. 
     * @param {string} n 
     * @returns string s with digit chars only
     */
    stripNonDigit(n:string){
        if(!n) return '';
            
        let n2 = '';
        for(let i=0; i<n.length; i++){
            let cc = n.charCodeAt(i);
            if(cc> 47 && cc < 58){
                let c = n.charAt(i);
                n2 = n2 + c;
            }
        }
        return n2;
    }

}